import { IAdAdapter } from "./IAdAdapter";

export class RichAdsAdapter implements IAdAdapter {
  readonly name = "richads";

  constructor(private blockId: string) {}

  isAvailable(): boolean {
    const ctrl = (window as any).RichAdsCtrl;
    return !!ctrl && typeof ctrl.triggerNativeNotification === "function";
  }

  async requestAd(_type: "rewarded" | "interstitial"): Promise<boolean> {
    const ctrl = (window as any).RichAdsCtrl;
    if (!ctrl) throw new Error("no RichAdsCtrl");
    if (!ctrl.triggerNativeNotification) throw new Error("no triggerNativeNotification");
    // Check for initialization errors
    if ((window as any)._richAdsError) throw new Error("init error: " + (window as any)._richAdsError);
    return true;
  }

  async showAd(): Promise<boolean> {
    const ctrl = (window as any).RichAdsCtrl;
    if (!ctrl?.triggerNativeNotification) throw new Error("SDK not ready");
    try {
      await Promise.race([
        ctrl.triggerNativeNotification(true),
        new Promise<never>((_, rej) => setTimeout(() => rej(new Error("timeout")), 10000)),
      ]);
      return true;
    } catch (err) {
      throw new Error("richads show failed: " + ((err as any)?.message || err));
    }
  }

  async showAdInterstitial(): Promise<void> {
    const ctrl = (window as any).RichAdsCtrl;
    if (!ctrl?.triggerNativeNotification) throw new Error("SDK not ready");
    try {
      await Promise.race([
        ctrl.triggerNativeNotification(false), // false = non-motivated (interstitial)
        new Promise<never>((_, rej) => setTimeout(() => rej(new Error("timeout")), 10000)),
      ]);
    } catch (err) {
      throw new Error("richads inter failed: " + ((err as any)?.message || err));
    }
  }
}
